import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

function SitemapTool() {
  const [url, setUrl] = useState("");
  const [maxPages, setMaxPages] = useState(1000);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const generateSitemap = async () => {
    if (!url) {
      setError("Please enter a valid website URL.");
      return;
    }

    setError("");

    try {
      setLoading(true);

      const response = await axios.post(
        "https://darkgoldenrod-bee-402758.hostingersite.com/api/sitemap/generate",
        { url, maxPages },
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: "application/xml" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "sitemap.xml";
      link.click();

    } catch (err) {
      setError("Failed to generate sitemap. Please check the URL.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand mb-0 h1">
          Sitemap Generator
        </span>
      </nav>

      {/* MAIN CONTENT */}
      <div className="container d-flex justify-content-center align-items-center"
           style={{ minHeight: "90vh" }}>

        <div className="card shadow-lg p-4" style={{ width: "100%", maxWidth: "500px" }}>
          <h4 className="mb-4 text-center">Generate XML Sitemap</h4>

          {error && (
            <div className="alert alert-danger py-2">{error}</div>
          )}

          <div className="mb-3">
            <label className="form-label">Website URL</label>
            <input
              type="text"
              className="form-control"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Maximum Pages to Crawl</label>
            <input
              type="number"
              className="form-control"
              value={maxPages}
              onChange={(e) => setMaxPages(Number(e.target.value))}
            />
          </div>

          <button
            className="btn btn-primary w-100"
            onClick={generateSitemap}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Generating...
              </>
            ) : (
              "Generate Sitemap"
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default SitemapTool;